import { render, staticRenderFns } from "./log.vue?vue&type=template&id=a636dd52&scoped=true"
import script from "./log.vue?vue&type=script&lang=js"
export * from "./log.vue?vue&type=script&lang=js"
import style0 from "./log.vue?vue&type=style&index=0&id=a636dd52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a636dd52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a636dd52')) {
      api.createRecord('a636dd52', component.options)
    } else {
      api.reload('a636dd52', component.options)
    }
    module.hot.accept("./log.vue?vue&type=template&id=a636dd52&scoped=true", function () {
      api.rerender('a636dd52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/fixed/components/log.vue"
export default component.exports